<template>
  <div :class="card_style">
    <div><slot name="body" /></div>
    <div><slot name="close-button" /></div>
    <div v-if="$slots.ctas"><slot name="ctas" /></div>
  </div>
</template>
<script setup>
import { computed } from "vue";

const props = defineProps({
  variant: { type: String, default: "primary" },
  has_error_outline: { type: Boolean, default: false },
  has_info_outline: { type: Boolean, default: false },
  has_warning_outline: { type: Boolean, default: false },
  has_success_outline: { type: Boolean, default: false },
  button_flex: { type: Boolean, default: false },
});
const card_style = computed(() => {
  let base = props.button_flex
    ? "justify-between gap-3 md:gap-0 flex flex-col md:flex-row p-3 md:p-4 md:items-center rounded-2xl border-[2px] md:space-x-3 relative"
    : "flex-col md:flex-row p-3 md:p-4 md:items-center rounded-2xl border-[2px] space-y-3 relative";

  let color_map = {
    primary: "bg-bg-canvas",
    secondary: "bg-container-bg",
  };
  let color_style = color_map[props.variant] || color_map["primary"];
  let border_map = {
    primary: "border-bg-canvas",
    secondary: "border-container-bg",
  };

  let border_color = border_map[props.variant] || border_map["primary"];

  if (props.has_error_outline) {
    border_color = "border-outline-error";
  }

  if (props.has_info_outline) {
    border_color = "border-blue-800";
  }

  if (props.has_warning_outline) {
    border_color = "border-outline-warning";
  }

  if (props.has_success_outline) {
    border_color = "border-outline-success";
  }

  return [base, color_style, border_color].join(" ");
});
</script>
